import { useEffect } from 'react';
import { ReactNode } from 'react';

interface VsjSheetProps {
  open: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  ctaLabel?: string;
  /** Hide the default CTA button when the sheet provides its own actions. */
  hideCta?: boolean;
}

/**
 * Bottom sheet for secondary content — honest "coming soon" states, notices.
 * Replaces every native alert()/confirm() in the experience.
 */
export function VsjSheet({ open, title, children, onClose, ctaLabel = 'Entendido', hideCta = false }: VsjSheetProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="vsj-sheet-root" role="dialog" aria-modal="true" aria-label={title}>
      <div className="vsj-sheet-backdrop" onClick={onClose} />
      <div className="vsj-sheet">
        <div className="vsj-sheet-handle" aria-hidden="true" />
        <h3 className="vsj-sheet-title">{title}</h3>
        <div className="vsj-sheet-body">{children}</div>
        {!hideCta && (
          <button className="vsj-btn-primary" onClick={onClose}>
            {ctaLabel}
          </button>
        )}
      </div>
    </div>
  );
}
